import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { FloatInput, FloatSelect } from "src/componentes";
import {
  CTeDto,
  finalidadeCteOptions,
  getLocal,
  modalOptions,
  retiraOptions,
  STORAGECTE_KEY,
  tipoCteOptions,
  tipoServicoOptions,
  tipoTomadorOptions,
  updateLocal,
} from "../CTe.Dto";
import {
  CaracteristicasFormType,
  CaracteristicasSchema,
} from "./CTe.Cadastro.Dto";
import CTeConfiguracaoCode from "../CTe.Configuracao.Code";
import { TipoConfiguracaoEnum } from "src/pages/Privada/Configuracoes/Sistema/Sistema.Dto";

const CTeCadastroCaracteristicasView = () => {
  const navigate = useNavigate();
  const configuracao = CTeConfiguracaoCode();
  const cte = getLocal<CTeDto>(STORAGECTE_KEY);

  const form = useForm<CaracteristicasFormType>({
    resolver: yupResolver(CaracteristicasSchema),
    defaultValues: {
      tipoCte: cte?.tipoCte ?? 0,
      tipoServico: cte?.tipoServico ?? 0,
      finalidadeCte: cte?.finalidadeCte ?? 0,
      modal: cte?.modal ?? 1,
      retira: cte?.retira ?? 1,
      tipoTomador: cte?.tipoTomador ?? 3,
      rntrc: cte?.rntrc ?? "",
    },
  });

  const handleVoltar = () => {
    navigate("/fiscal/cte");
  };

  const onSubmit = (data: CaracteristicasFormType) => {
    const serieConfig = Number(
      configuracao.getConfiguracaoValor(TipoConfiguracaoEnum.Serie)
    );

    updateLocal<CTeDto>(STORAGECTE_KEY, {
      tipoCte: Number(data.tipoCte),
      tipoServico: Number(data.tipoServico),
      finalidadeCte: Number(data.finalidadeCte),
      modal: Number(data.modal),
      retira: Number(data.retira),
      tipoTomador: Number(data.tipoTomador),
      rntrc: data.rntrc,
      serie: cte?.serie || (serieConfig > 0 ? serieConfig : 1),
      numeroCte: cte?.numeroCte ?? 0,
    });

    navigate("../percurso");
  };

  return (
    <Form noValidate onSubmit={form.handleSubmit(onSubmit)} className="mt-3 mb-5">
      <Row className="g-3">
        <Col xs={12} md={6}>
          <FloatSelect
            label="Tipo do CT-e"
            options={tipoCteOptions}
            register={form.register("tipoCte", { valueAsNumber: true })}
            errorsMessage={form.formState.errors.tipoCte}
          />
        </Col>

        <Col xs={12} md={6}>
          <FloatSelect
            label="Tipo de Serviço"
            options={tipoServicoOptions}
            register={form.register("tipoServico", { valueAsNumber: true })}
            errorsMessage={form.formState.errors.tipoServico}
          />
        </Col>

        <Col xs={12} md={4}>
          <FloatSelect
            label="Finalidade"
            options={finalidadeCteOptions}
            register={form.register("finalidadeCte", { valueAsNumber: true })}
            errorsMessage={form.formState.errors.finalidadeCte}
          />
        </Col>

        <Col xs={12} md={4}>
          <FloatSelect
            label="Modal"
            options={modalOptions}
            register={form.register("modal", { valueAsNumber: true })}
            errorsMessage={form.formState.errors.modal}
          />
        </Col>

        <Col xs={12} md={4}>
          <FloatSelect
            label="Recebimento / Retira"
            options={retiraOptions}
            register={form.register("retira", { valueAsNumber: true })}
            errorsMessage={form.formState.errors.retira}
          />
        </Col>

        <Col xs={12} md={6}>
          <FloatSelect
            label="Tomador do Serviço"
            options={tipoTomadorOptions}
            register={form.register("tipoTomador", { valueAsNumber: true })}
            errorsMessage={form.formState.errors.tipoTomador}
          />
        </Col>

        <Col xs={12} md={6}>
          <FloatInput
            label="RNTRC"
            registerField={form.register("rntrc")}
            errorsMessage={form.formState.errors.rntrc}
            inputMask="int"
          />
        </Col>
      </Row>

      <div className="fixed-bottom">
        <Container className="py-3">
          <Row>
            <Col xs={6} className="d-grid">
              <Button variant="outline-secondary" onClick={handleVoltar}>
                Voltar
              </Button>
            </Col>
            <Col xs={6} className="d-grid">
              <Button variant="outline-primary" type="submit">
                Próximo
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </Form>
  );
};

export default CTeCadastroCaracteristicasView;
